import React from 'react';
import './CompanyPages.css';
import useScrollToTop from '../components/useScrollToTop';
import ReusableLanding from '../components/ReusableLanding';
import image2 from '../img/dream_home.avif';
import teamImage from '../img/kitchen_modern_classic.webp';
import sustainableImage from '../img/ideas_img_1.avif';
import clientMeeting from '../img/Untbedroom.avif';

const OurStory = () => {
  useScrollToTop();
  return (
    <>
      <ReusableLanding
        imageUrl={image2}
        title="Our Story: Building Dreams, Brick by Brick in Patna"
        description="Housekaar was founded in Patna with a vision to transform the way people experience home design and construction. We believe in creating spaces that are not only aesthetically pleasing but also deeply functional, sustainable, and reflective of the unique needs of our clients in Bihar."
      />
      <div className="company-page">
        <section className="story-section">
          <h2>The Foundation: Rooted in Patna's Spirit</h2>
          <p>
            Housekaar's journey began with a shared passion among a group of local architects and construction experts in Patna. Witnessing the evolving needs and aspirations of homeowners in our community, we envisioned a company that could bridge the gap between innovative design and quality construction, all while understanding the specific context of building in Bihar. Our initial projects focused on residential homes, and our commitment to personalized service and attention to detail quickly earned us a reputation for reliability and excellence within Patna.
          </p>
          <div className="post-image">
            <img src={teamImage} alt="Our Founding Team" loading="lazy"/>
            <p className="caption">Collaboration and expertise are at the heart of Housekaar.</p>
          </div>
        </section>

        <section className="story-section">
          <h2>Our Mission: Crafting Spaces, Exceeding Expectations</h2>
          <p>
            Our mission is to provide exceptional architectural and construction services, delivering innovative and personalized solutions to our clients across Patna and beyond. We strive to not only meet but exceed expectations, building lasting relationships based on trust, transparency, and a shared vision for creating remarkable spaces. We are deeply committed to understanding the unique lifestyles and preferences of our clients in Bihar to craft homes that truly resonate with them.
          </p>
        </section>

        <section className="story-section">
          <h2>Our Values: The Pillars of Housekaar</h2>
          <ul>
            <li>
              <strong>Integrity:</strong> We conduct all our business dealings in Patna and beyond with unwavering honesty, transparency, and ethical practices.
            </li>
            <li>
              <strong>Quality:</strong> We are committed to delivering the highest standards of workmanship and using quality materials that are suitable for the local climate and conditions in Bihar.
            </li>
            <li>
              <strong>Innovation:</strong> We embrace new technologies, sustainable design principles relevant to Patna, and modern construction approaches to create forward-thinking spaces.
              <div className="post-image">
                <img src={sustainableImage} alt="Sustainable Design Principles" loading="lazy"/>
                <p className="caption">Integrating sustainable practices for a better future in Bihar.</p>
              </div>
            </li>
            <li>
              <strong>Customer Focus:</strong> We prioritize the needs and satisfaction of our clients in Patna, ensuring open communication and a collaborative approach throughout every project.
              <div className="post-image">
                <img src={clientMeeting} alt="Client Collaboration" loading="lazy"/>
                <p className="caption">Working closely with our clients to bring their vision to life.</p>
              </div>
            </li>
            <li>
              <strong>Community Commitment:</strong> As a company rooted in Patna, we are dedicated to contributing positively to our local community through responsible building practices and supporting local talent.
            </li>
          </ul>
        </section>

        <section className="story-section">
          <h2>Our Journey: From Local Roots to Regional Recognition</h2>
          <p>
            Since our inception in Patna, Housekaar has steadily grown from a dedicated team of local professionals to a recognized construction company serving clients across Bihar. We have successfully completed a diverse portfolio of projects, ranging from contemporary residential homes to innovative commercial spaces. Our journey has been marked by a consistent pursuit of excellence, a deep understanding of the local context, and the trust we've built with our clients in Patna and the surrounding regions. We are proud of our roots in Bihar and look forward to continuing to build and shape our community for years to come.
          </p>
        </section>
      </div>
    </>
  );
};

export default OurStory;